// Single source of truth for the "unlock one episode" price shown in paywall CTAs.
// Keep this in sync with the Game Day tier in PricingSection.
export const SINGLE_EPISODE_PRICE = '$5.99';
